import React from 'react';
import PropTypes from 'prop-types';
import { Helmet } from 'react-helmet';

// https://www.gatsbyjs.com/docs/add-seo-component/

const Head = () => (
  <Helmet title="Amit Mishra" defaultTitle="Amit Mishra" titleTemplate={`%s | Amit Mishra`}>
    <html lang="en" />

    <meta name="description" content="Amit Mishra | SDE3" />
    <meta name="image" content="../images/me.jpg" />

    <meta property="og:title" content="Amit Mishra" />
    <meta property="og:description" content="Amit Mishra | SDE3" />
    <meta property="og:image" content="../images/me.jpg" />
    <meta property="og:url" content="" />
    <meta property="og:type" content="website" />

    <meta name="twitter:card" content="summary_large_image" />
    <meta name="twitter:creator" content="Developer_AmitM" />
    <meta name="twitter:title" content="Amit Mishra" />
    <meta name="twitter:description" content="Amit Mishra | SDE3" />
    <meta name="twitter:image" content="../images/me.jpg" />

    <meta name="google-site-verification" content="" />
  </Helmet>
);

export default Head;

Head.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  image: PropTypes.string,
};

Head.defaultProps = {
  title: null,
  description: null,
  image: null,
};
